import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TableRequestData } from '../../models/table/table-request-param';
import { Observable } from 'rxjs';
import { TableResponse } from '../../models/table-response';
import { Dokument } from '../../models/dokument';
import { HttpUtils } from '../../utils/http.utils';

@Injectable()
export class InboxApi {
  #httpClient: HttpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/inbox';

  public getAllSentApplicationDocuments(
    tableRequest: TableRequestData,
  ): Observable<TableResponse<Dokument>> {
    return this.#httpClient.get<TableResponse<Dokument>>(
      `${this.#apiUrl}/applications`,
      {
        params: HttpUtils.toHttpParams(tableRequest),
        withCredentials: true,
      },
    );
  }

  public getAllInboxDocuments(
    tableRequest: TableRequestData,
  ): Observable<TableResponse<Dokument>> {
    if (!tableRequest.sortBy) {
      tableRequest.sortBy = 'dataWplywu';
    }

    return this.#httpClient.get<TableResponse<Dokument>>(
      `${this.#apiUrl}/documents`,
      {
        params: HttpUtils.toHttpParams(tableRequest),
        withCredentials: true,
      },
    );
  }

  public getAllInboxDocumentsCount(): Observable<number> {
    return this.#httpClient.get<number>(
      `${this.#apiUrl}/documents/unread/count`,
      {
        withCredentials: true,
      },
    );
  }

  public archiveDocuments$(ids: Set<number>): Observable<number> {
    return this.#httpClient.get<number>(`${this.#apiUrl}/archive`, {
      params: HttpUtils.toHttpParams({ ids: Array.from(ids) }),
      withCredentials: true,
    });
  }

  public assignDocumentToOrganization$(
    documentId: number,
    organizationId: number,
  ): Observable<void> {
    return this.#httpClient.post<void>(
      `${this.#apiUrl}/assign-to-organization`,
      {},
      {
        params: {
          documentId: documentId.toString(),
          organizationId: organizationId.toString(),
        },
        withCredentials: true,
      },
    );
  }

  public restoreFromArchiveDocuments$(ids: Set<number>): Observable<number> {
    return this.#httpClient.get<number>(`${this.#apiUrl}/restoreFromArchive`, {
      params: HttpUtils.toHttpParams({ ids: Array.from(ids) }),
      withCredentials: true,
    });
  }

  signUPDDigitalSignature(documentId: number): Observable<any> {
    return this.#httpClient.post(
      `${this.#apiUrl}/${documentId}/receive`,
      {},
      {
        withCredentials: true,
        responseType: 'text',
      },
    );
  }
}
